import BidPeriodFileInfo from "./BidPeriodFileInfo";

export default class BidPeriodFileGroupInfo {
    "bidPeriodFileGroupId": number;
    "bidPeriodId": number;
    "groupType": string;
    "groupStatus": string;
    "statusDate": string;
    "bidPeriodFiles": BidPeriodFileInfo[];
}